import initMap from "./map-init";
//Section observe settings
const intersectionOptions = {
  root: null,
  rootMargin: "70px",
  threshold: 0,
};
//Create new observer for sections with section options and general section callback
const sectionObserver = new IntersectionObserver(
  sectionObserverCallBack,
  intersectionOptions
);

//Callback function for section intersection
function sectionObserverCallBack(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      
      if(entry.target.classList.contains('acf-map') && !window.googleMapLoaded){
        loadGoogleMaps(entry.target);
      }else{
        const lazyImages = entry.target.querySelectorAll('[data-lazy="true"]');
      
      if (lazyImages.length > 0) {
        lazyImages.forEach((image) => {
          image.dataset.src && (image.src = image.dataset.src);
          image.dataset.srcset && (image.srcset = image.dataset.srcset);
          image.dataset.sizes && (image.sizes = image.dataset.sizes);

          image.removeAttribute("data-src");
          image.removeAttribute("data-srcset");
          image.removeAttribute("data-sizes");
          image.removeAttribute("data-lazy");
        });
      }
      }
      sectionObserver.unobserve(entry.target);
    }
  });
}

//Callback to load Google Maps
function loadGoogleMaps(element) {
  
  const script = document.createElement('script');
  script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDYDtkkezl9_kjBruagNzmTE6yU9hTdIqM";
  script.async = true;
  script.onload = function(){
    initMap(element);
    window.googleMapLoaded = true;
  }
  document.head.appendChild(script);
}

window.addEventListener("load", () => {
  const sections = document.querySelectorAll("#content-sections .lazy-load");

  sections.forEach((section) => {
    sectionObserver.observe(section);
  });
});
